export class RowData {
  id?: number
  name?: string
  isActive?: boolean
  lastModificationTime?: string
  lastModifierUserName?: number
  creationTime?: Date
  creatorUserName?: string
}
